export default __webpack_public_path__ + "static/media/bb-poster-small.4738eeeb.jpg";